export interface Range {
  start: number;
  end: number;
}

export interface CompletionRange {
  range: Range;
  percentage: number;
  count: number;
}

export interface CompletionSummary {
  ranges: CompletionRange[];
  total_profiles: number;
  incomplete_profiles: number;
  incomplete_percentage: number;
}

export interface IncompleteField {
  field: string;
  incomplete_count: number;
  incomplete_percentage: number;
}

export interface TimeSeriesData {
  period: string;
  overall_completion_percentage: number;
}

export interface TimeSeries {
  grouping: string;
  data: TimeSeriesData[];
}

export interface ProfileCompletion {
  overall_completion_percentage: number;
  completion_summary: CompletionSummary;
  most_incomplete_fields: IncompleteField[];
  time_series: TimeSeries;
}
